module.exports = __webpack_public_path__ + "img/RBS04_6_loading.c5cd332d.jpg";